export const getWorkforceProfileDisplayId = (profile: {publicId?: string | null; resourceId: string}): string => {
  if (profile.publicId) {
    return profile.publicId;
  }

  return 'unknown';
};
